// Single source of truth for item types — these VALUES must match the backend
// InventoryManagement.Domain.Enums.ItemType enum names exactly (they bind to it
// via JsonStringEnumConverter). Used by the item form's Type field and by the
// Category/Form masters' "applies to item type" scope selector.
export interface ItemTypeOption { value: string; label: string }

export const ITEM_TYPES: ItemTypeOption[] = [
  { value: "Medicine",   label: "Medicine" },
  { value: "Consumable", label: "Consumable" },
  { value: "Surgical",   label: "Surgical" },
  { value: "Reagent",    label: "Reagent" },
  { value: "Asset",      label: "Asset" },
  { value: "NonStock",   label: "Non-stock" },
];

export const itemTypeLabel = (value?: string | null): string =>
  ITEM_TYPES.find(t => t.value === value)?.label ?? value ?? "";
